export default function normalizeCSV({
  haveIAP,
  selectedType,
  range,
  packageName,
}) {
  const { type, child, tag: selectedTag } = selectedType;
  const params = {
    packageName,
    range,
    stat_type: type,
    child,
  };
  if (selectedTag) params.tag = selectedTag;
  if (haveIAP) params.is_in_app = 1;
  return params;
}
